import { render, staticRenderFns } from "./MediaTab.vue?vue&type=template&id=6add8869&scoped=true&"
import script from "./MediaTab.vue?vue&type=script&lang=js&"
export * from "./MediaTab.vue?vue&type=script&lang=js&"
import style0 from "./MediaTab.vue?vue&type=style&index=0&id=6add8869&lang=scss&scoped=true&"
import style1 from "./MediaTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add8869",
  null
  
)

export default component.exports